"use strict";

import { weightUnitSelect } from './utilities.js';
// import mediumZoom from 'medium-zoom';

document.addEventListener('DOMContentLoaded', () => {
  weightUnitSelect();
  // mediumZoom('[data-zoomable]', {});
});
